import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'
import type { FavoriteResponse } from '#lib/types/account'

export interface FavoriteGames {
  data: FavoriteResponse[]
}

export const useFavoriteGamesStore = defineStore(AppStoreEnum.FavoriteGames, {
  state: (): FavoriteGames => ({
    data: [],
  }),
  persist: false,
  actions: {
    setFavoriteGames(data: FavoriteResponse[]): void {
      this.data = data
    },
    getFavoriteGames(): FavoriteResponse[] {
      return this.data
    },
    reset() {
      this.data = []
    },
  },
})
